module.exports = __webpack_public_path__ + "img/Extra2.a96ae764.png";